import { type PlanOfCareReviewViewModel } from '@generated';
import { Section } from '~/shared/section/Section';
import { SectionHeader } from '~/shared/section/SectionHeader';

export function ReviewTab({ review }: { review: PlanOfCareReviewViewModel }) {
	return (
		<Section>
			<SectionHeader title="Review" />
			<p>test</p>
		</Section>
	);
}
